import { motion } from "framer-motion";
import { STANDARDS, PROCESS } from "@/data";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

const IMG = "/work-3-clean.webp";

export default function Standards() {
  return (
    <section
      id="standards"
      data-testid="standards-section"
      className="scroll-mt-20 border-t border-[#2a2a2a] bg-[#050505] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid grid-cols-1 gap-16 md:grid-cols-12 md:gap-10">
          {/* Left: sticky intro + image */}
          <div className="md:col-span-5">
            <div className="md:sticky md:top-28">
              <Reveal><Eyebrow>Standards & documentation</Eyebrow></Reveal>
              <Reveal i={1}>
                <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-[#f5f5f0] sm:text-5xl">
                  Aligned to current IICRC Standards.
                </h2>
              </Reveal>
              <Reveal i={2}>
                <p className="mt-5 max-w-md text-base leading-relaxed text-[#8a8a8a]">
                  A structured approach to assessment, containment,
                  decontamination and safe handover — the due diligence that
                  complex sites demand.
                </p>
              </Reveal>
              <Reveal i={3}>
                <div className="mt-8 overflow-hidden border border-[#2a2a2a]">
                  <motion.img
                    src={IMG}
                    alt="Certified remediation technician"
                    className="aspect-[4/5] w-full object-cover grayscale transition-all duration-700 hover:grayscale-0"
                    whileHover={{ scale: 1.04 }}
                    transition={{ duration: 0.7 }}
                  />
                </div>
              </Reveal>
            </div>
          </div>

          {/* Right: manifesto chapters */}
          <div className="md:col-span-7">
            {STANDARDS.map((s, i) => (
              <Reveal
                key={s.code}
                i={i}
                className="grid grid-cols-12 gap-4 border-b border-[#2a2a2a] py-10 first:border-t"
              >
                <div className="col-span-12 md:col-span-4">
                  <span className="font-display text-5xl font-semibold tracking-tighter text-[#c4a962] md:text-6xl">
                    {s.code}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-8">
                  <h3 className="font-display text-2xl font-medium tracking-tight text-[#f5f5f0]">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-[#8a8a8a]">
                    {s.desc}
                  </p>
                </div>
              </Reveal>
            ))}

            {/* Process */}
            <div className="mt-14">
              <Reveal><Eyebrow>Our process</Eyebrow></Reveal>
              <div className="mt-6 flex flex-col">
                {PROCESS.map((p, i) => (
                  <Reveal
                    key={p.n}
                    i={i}
                    className="group flex items-baseline gap-5 border-t border-[#1a1a1a] py-4 transition-colors duration-300 hover:bg-[#121212]"
                  >
                    <span className="font-display text-sm text-[#8a8a8a] group-hover:text-[#c4a962]">
                      {p.n}
                    </span>
                    <span className="w-48 shrink-0 font-display text-lg tracking-tight text-[#f5f5f0]">
                      {p.t}
                    </span>
                    <span className="text-sm text-[#8a8a8a]">{p.d}</span>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
